import React from 'react'
import './know-before-you-code.css'
import {
  KnowBeforeYouCodeCard,
  KnowBeforeYouCodeCardProps,
} from './KnowBeforeYouCodeCard'

export interface IKnowBeforeYouCodeWrapperProps {
  cards: KnowBeforeYouCodeCardProps[]
}

export const KnowBeforeYouCodeWrapper: React.FC<
  IKnowBeforeYouCodeWrapperProps
> = ({ cards, children }) => {
  return (
    <>
      <h2 className="newH2 know_berofe_you_code_title">Know before you code</h2>
      <div className={`know_berofe_you_code_wrapper`}>
        {cards &&
          Array.isArray(cards) &&
          cards.forEach((card, i) => (
            <KnowBeforeYouCodeCard
              title={card.title}
              primaryType={card.primaryType}
              primaryLink={card.primaryLink}
              primaryLabel={card.primaryLabel}
              tertiaryLabel={card.tertiaryLabel}
              tertiaryLink={card.tertiaryLink}
              listElements={card.listElements}
            />
          ))}
        {children}
      </div>
    </>
  )
}

export default KnowBeforeYouCodeWrapper
